import { type StateCreator } from "zustand";
import { TTemplateTopGridData } from "../../core/types/add-manage-template";
import { TAddCategorySchema } from "../../core/types/add-template-validate";

export type TManageTemplateInfo = {
  templateInfo: TTemplateTopGridData;
  categoryZustandArray: TAddCategorySchema[];
};
export type TManageTemplateStoreState = {
  templateInfo: TTemplateTopGridData;
  categoryZustandArray: TAddCategorySchema[];
} & Partial<Record<string, any>>;

export type TCommonStoreActions = {
  setTemplateInfo: (value: TTemplateTopGridData) => void;
  setCategoryInfo: (value: TAddCategorySchema[]) => void;
  setResetTemplateInfo: () => void;
};

const initialManageTemplateStoreState: TManageTemplateInfo = {
  templateInfo: {
    name: "",
    description: "",
    entity: "",
    campaigns: [],
    service: "",
    start_date: "",
    end_date: "",
    scoring_type: "",
    all_selected_campaigns:false
  },
  categoryZustandArray: [],
};

export type TManageTemplateStore = TCommonStoreActions &
  TManageTemplateStoreState;

export const CreateManageTemplateSlice: StateCreator<TManageTemplateStore> = (
  set,
) => ({
  ...initialManageTemplateStoreState,
  setTemplateInfo: (value) =>
    set(() => ({
      templateInfo: value,
    })),

  setCategoryInfo: (value) =>
    set(() => ({
      categoryZustandArray: value,
    })),

  setResetTemplateInfo: () =>
    set(() => ({
      templateInfo: initialManageTemplateStoreState.templateInfo,
    })),
});
